export default __webpack_public_path__ + "static/media/detergent.9596fc00.png";